// Context for the tabs component

import { createContext, useState } from 'react'

export const StateTabContext = createContext<{
  activeTab: string | null
  setActiveTab: (tab: string | null) => void
  tabs: string[]
  groupName: string
} | null>(null)

export const StateTabProvider = ({
  children,
  tabs,
  groupName = 'tab',
}: {
  children: React.ReactNode | ((activeTab: string | null) => React.ReactNode)
  tabs: string[]
  groupName?: string
}) => {
  if (tabs.length === 0) {
    throw new Error('Tabs array cannot be empty')
  }
  const [activeTab, setActiveTab] = useState<string | null>(tabs[0])

  const changeTab = (tab: string | null) => {
    setActiveTab(tab)
  }

  return (
    <StateTabContext.Provider value={{ activeTab, setActiveTab: changeTab, tabs, groupName }}>
      {typeof children === 'function' ? children(activeTab) : children}
    </StateTabContext.Provider>
  )
}
